import { Editor } from '@tiptap/core';

type MarkdownStorage = {
  markdown: {
    getMarkdown: () => string;
  };
};

export function getMarkdown(editor: Editor): string {
  // Tiptap's editor.storage is typed as Record<string, any> but the tiptap-markdown
  // extension populates storage.markdown at runtime. There is no public type export
  // for this structure, so we assert to the known shape.
  const storage = editor.storage as unknown as MarkdownStorage;
  return storage.markdown.getMarkdown();
}
